
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2871',
  depVersions: {
  "customer-portal-app": "static-1.2871",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.489",
  "data-fetching-client": "static-1.9836",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25915",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5770",
  "hs-test-utils": "static-1.8199",
  "hub-http": "static-1.6396",
  "hub-http-shared-msw-handlers": "static-1.10403",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18751",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11652",
  "I18n": "static-7.1645",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6632",
  "payment-link-components": "static-1.23919",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7266",
  "quartz-core": "static-1.6485",
  "quartz-i18n": "static-1.941",
  "react": "static-7.189",
  "react-colorpicker": "static-2.10384",
  "react-dlb": "static-1.83",
  "react-utils": "static-2.5468",
  "reselect": "static-3.8",
  "rich-text-lib": "static-1.20138",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18224",
  "ui-components-test-utils": "static-1.5789",
  "UIComponents": "static-3.8598",
  "foundations-assets": "static-1.5051",
  "foundations-components": "static-1.8278",
  "foundations-theming": "static-1.4615",
  "foundations-theming-specialty": "static-1.2331",
  "framer-motion": "static-1.75",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1243",
  "quartz-config": "static-1.1044",
  "quartz-routing": "static-1.696",
  "quick-fetch": "static-1.4044",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16878",
  "rpc-client-utils": "static-1.4834",
  "sanitize-text": "static-1.8322",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.58",
  "ui-addon-draggable": "static-3.4934",
  "ui-addon-react-router-dom": "static-1.9711",
  "usage-tracker": "static-1.7528",
  "usage-tracker-anonymous": "static-1.5945",
  "usage-tracker-core": "static-1.7378",
  "video-components-external": "static-1.11864",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3528",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3543",
  "quartz-webpack": "static-1.3490",
  "bend-plugin-quartz-routing": "static-1.344",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "customer-data-objects": "static-1.7856",
  "frontend-preferences-client": "static-1.8104",
  "laboratory-lib": "static-3.7328",
  "onboarding-scopes": "static-1.6635",
  "seat-types-lib": "static-1.408",
  "ui-addon-opt": "static-4.8537",
  "HeadJS": "static-2.777",
  "hs-test-utils-bend-plugin": "static-1.3310",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.208",
  "ts-schema": "static-1.4207",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8025",
  "content-media-capture": "static-1.5093",
  "cssUtils": "static-1.843",
  "customer-data-ui-utilities": "static-1.10002",
  "file-manager-components": "static-1.24148",
  "HubStyle": "static-2.11959",
  "knowledge-content-types": "static-1.8584",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.491",
  "ui-addon-emoji-picker": "static-1.10060",
  "ui-addon-i18n": "static-1.11325",
  "ui-business-units-lib": "static-1.9257",
  "ui-shepherd-react": "static-3.10439",
  "video-data-lib": "static-1.35522",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4500",
  "commerce-tours-lib": "static-1.6435",
  "customer-data-properties": "static-1.52186",
  "getting-started-shared-tasks": "static-1.18941",
  "growth-onboarding-reliability": "static-1.5259",
  "onboarding-tours": "static-1.16937",
  "reference-resolvers-lite": "static-1.8273",
  "sales-checkout-service-client": "static-1.3743",
  "ui-addon-iframeable": "static-1.9252",
  "user-context": "static-1.5287",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.852",
  "hubspotter-http": "static-1.4778",
  "icons": "static-2.665",
  "mobile-manifest-mixins": "static-1.551",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.941",
  "quartz-head": "static-1.931",
  "quartz-test": "static-1.941",
  "quartz-tracking": "static-1.645",
  "trellis-components": "static-1.2304",
  "ui-fonts": "static-1.914",
  "usage-tracker-container": "static-1.7518",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9602",
  "data-token-picker": "static-1.16720",
  "FileManagerLib": "static-1.39788",
  "property-translator": "static-1.5570",
  "atom": "static-1.5252",
  "merchandise-lib": "static-1.267",
  "purchase-motions-components": "static-1.6177",
  "salesImages": "static-1.529",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5761",
  "react-create-root-preference": "static-1.45",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.102",
  "ui-images": "static-2.1206",
  "bend-plugin-foundations-components": "static-1.4547",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "trellis-assets": "static-1.2285",
  "bend-plugin-foundations-theming": "static-1.3098",
  "foundations-theming-base": "static-1.3600",
  "stylex": "static-1.37",
  "interframe": "static-3.4932",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5942",
  "web-vitals": "static-1.9",
  "bend-plugin-chirp-manifest": "static-1.244",
  "chirp-fetch": "static-1.2064",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4654",
  "react-flip-move": "static-1.74",
  "apollo-link-hub-http": "static-2.4828",
  "content-media-composition-data-lib": "static-1.12897",
  "content-media-compositions": "static-2.16904",
  "idb-keyval": "static-1.47",
  "immer": "static-1.33",
  "immerable": "static-1.4325",
  "magpie-lib": "static-1.5671",
  "magpie-types": "static-1.5131",
  "media-bridge-lib": "static-1.19235",
  "bender-build-tools": "static-1.3308",
  "inbound-db-properties-service-client": "static-1.3973",
  "superstore": "static-1.4935",
  "feedback-loader": "static-1.29627",
  "ai-components-ui-library": "static-1.9409",
  "ui-addon-video-player": "static-1.8882",
  "ui-coaching-tips": "static-1.29061",
  "ContentUtils": "static-1.68892",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4602",
  "sassPrefix": "static-1.160",
  "react-dnd-compat": "static-1.4791",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1361",
  "copilot-toolkit": "static-1.11593",
  "avatar-components": "static-1.2675",
  "navigation-messaging": "static-1.7834",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8352",
  "commerce-products-lib": "static-1.10228",
  "crm-message-bus": "static-1.43491",
  "growth-data-modal": "static-1.5719",
  "hubspot-apollo-client": "static-1.5053",
  "onboarding-tours-client": "static-1.5151",
  "calling-global-api": "static-1.65119",
  "calling-internal-common": "static-1.31489",
  "calling-lifecycle-internal": "static-1.66501",
  "calling-lifecycle-messages": "static-1.58795",
  "conditional-properties-service-client": "static-1.3924",
  "crm-links": "static-1.6491",
  "crm-pipelines-api-client-types": "static-1.4265",
  "customer-data-objects-ui-components": "static-1.13207",
  "customer-data-properties-shared-msw-handlers": "static-1.9730",
  "customer-data-property-utils": "static-1.8273",
  "external-options-client-types": "static-1.4253",
  "formula-editor": "static-1.14572",
  "framework-data-schema-resolvers": "static-1.7071",
  "google-libphonenumber": "static-1.41",
  "hs-resources": "static-1.355",
  "inbound-db-meta-service-client": "static-1.3715",
  "inbounddb-objects-service-types": "static-1.4344",
  "meetings-icalendar-utils-lib": "static-1.809",
  "multi-currency-client-types": "static-1.3819",
  "object-builder-ui-client": "static-1.49327",
  "pipeline-validation-client-types": "static-1.4094",
  "property-value-citations": "static-1.2800",
  "pulse": "static-1.791",
  "smart-property-lib": "static-1.8059",
  "tiered-pricing": "static-1.1723",
  "topics-actions-lib": "static-1.326",
  "ui-addon-form-validation": "static-1.11166",
  "zustand": "static-1.74",
  "growth-onboarding-confetti": "static-1.3239",
  "growth-onboarding-next-action-utils": "static-1.2442",
  "navigation-components": "static-1.18507",
  "onboarding-tours-utils": "static-1.1003",
  "ui-shepherd-tracker": "static-1.7820",
  "ui-universal-auth": "static-1.9186",
  "batch-promise": "static-1.1721",
  "getting-started-shared-tasks-store": "static-1.18059",
  "hubspotter-http-shared-msw-handlers": "static-1.10401",
  "usage-tracker-session-replay": "static-1.5214",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1125",
  "tanstack-virtual": "static-1.33",
  "audio-components": "static-1.6180",
  "FileManagerCore": "static-1.39647",
  "FileManagerImages": "static-1.37299",
  "video-components": "static-1.13866",
  "foundations-components-legacy": "static-1.1303",
  "purchase-motions-api": "static-1.6180",
  "signup-constants": "static-1.19321",
  "signup-ui-url-generator": "static-2.8235",
  "usage-tracker-public": "static-1.7339",
  "reactive-lib": "static-1.901",
  "simple-logging-lib": "static-1.3226",
  "chatspot-core": "static-1.22221",
  "growth-onboarding-feedback-components": "static-1.6756",
  "cms-field-types": "static-1.4991",
  "content-icons-ui": "static-1.2279",
  "integrations-lib": "static-1.16724",
  "underscore": "static-1.8",
  "breeze-engine-core": "static-1.639",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.952",
  "customer-data-tracking": "static-1.7062",
  "products-iframe-lib": "static-1.8363",
  "products-ui-components-shared-msw-handlers": "static-1.10785",
  "restore-request-side-panel-lib": "static-1.1368",
  "onboarding-data-sync-lib": "static-1.2266",
  "hubspot-apollo-cache": "static-1.512",
  "calling-error-reporting": "static-1.31496",
  "shared-worker-versioning": "static-1.11213",
  "calling-usage-tracker": "static-1.6717",
  "voice-sms-access-library": "static-1.1636",
  "conversations-skeleton-state": "static-1.7425",
  "location-customization-utils-lib": "static-1.9788",
  "bark-lib": "static-1.16663",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6064",
  "react-codemirror": "static-1.10810",
  "fdsr-migration-layer": "static-1.190",
  "framework-builder-read-service-client": "static-1.4133",
  "framework-data-schema-quick-fetch": "static-1.6976",
  "persist-promise": "static-1.3878",
  "event-emitter": "static-1.1127",
  "bend-plugin-pulse": "static-1.294",
  "fast-json-patch": "static-1.66",
  "data-agent-kit": "static-1.474",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10486",
  "fsm": "static-1.3906",
  "policy-lib": "static-1.6962",
  "react-tinymce": "static-1.55720",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10549",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54846",
  "tinymce-plugins": "static-1.57960",
  "tinymce-themes": "static-1.56816",
  "growth-onboarding-next-action-components": "static-1.2470",
  "user-context-client": "static-1.4727",
  "nest": "static-1.412",
  "unified-auth-core-lib": "static-1.982",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4708",
  "video-embed": "static-1.36356",
  "social-insights-client-types": "static-1.22548",
  "flux-actions": "static-1.352",
  "integrations-error-boundary-lib": "static-1.14139",
  "integrations-tracking-lib": "static-1.5784",
  "native-integrations-shared-strings": "static-1.7957",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10541",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.700",
  "sales-views-client-types": "static-1.4435",
  "InboxConnectUtils": "static-4.15297",
  "meetings-connect-utils-lib": "static-1.7783",
  "calling-orchestration-schema": "static-1.36413",
  "crm-record-cards-service-types": "static-1.3712",
  "react-reducer-toolkit": "static-1.16094",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.107",
  "trellis-story-utils": "static-1.4683",
  "storybook-react": "static-1.36",
  "hub-http-contrib": "static-1.3219",
  "tinymce-data": "static-1.40931",
  "ui-addon-sales-email": "static-1.5389",
  "layout-dnd-components": "static-1.12787",
  "layout-dnd-utils": "static-1.11762",
  "ui-brand-identity-lib": "static-1.15942",
  "NamespacedHubStyle": "static-2.9178",
  "outpost": "static-1.4344",
  "universal-page-editor-lib": "static-1.3189",
  "adobe-sign-auth-lib": "static-1.204",
  "ads-unified-auth-lib": "static-1.697",
  "google-sheets-integration-lib": "static-1.769",
  "microsoft-drive-integration-lib": "static-1.878",
  "surveymonkey-integration-lib": "static-1.219",
  "slack-ui-library": "static-1.10574",
  "ContentData": "static-1.68967",
  "layout-data-lib": "static-1.10087",
  "advanced-menus-core": "static-1.15421",
  "advanced-menus-lib": "static-1.12316",
  "ExportDialog": "static-6.10556",
  "ui-memberships-settings-lib": "static-1.34537",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15420",
  "simple-menus-lib": "static-1.16937"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2871",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.489",
  "data-fetching-client": "/data-fetching-client/static-1.9836",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25915",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5770",
  "hs-test-utils": "/hs-test-utils/static-1.8199",
  "hub-http": "/hub-http/static-1.6396",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10403",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18751",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11652",
  "I18n": "/I18n/static-7.1645",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6632",
  "payment-link-components": "/payment-link-components/static-1.23919",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7266",
  "quartz-core": "/quartz-core/static-1.6485",
  "quartz-i18n": "/quartz-i18n/static-1.941",
  "react": "/react/static-7.189",
  "react-colorpicker": "/react-colorpicker/static-2.10384",
  "react-dlb": "/react-dlb/static-1.83",
  "react-utils": "/react-utils/static-2.5468",
  "reselect": "/reselect/static-3.8",
  "rich-text-lib": "/rich-text-lib/static-1.20138",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18224",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5789",
  "UIComponents": "/UIComponents/static-3.8598",
  "foundations-assets": "/foundations-assets/static-1.5051",
  "foundations-components": "/foundations-components/static-1.8278",
  "foundations-theming": "/foundations-theming/static-1.4615",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2331",
  "framer-motion": "/framer-motion/static-1.75",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1243",
  "quartz-config": "/quartz-config/static-1.1044",
  "quartz-routing": "/quartz-routing/static-1.696",
  "quick-fetch": "/quick-fetch/static-1.4044",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16878",
  "rpc-client-utils": "/rpc-client-utils/static-1.4834",
  "sanitize-text": "/sanitize-text/static-1.8322",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.58",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4934",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9711",
  "usage-tracker": "/usage-tracker/static-1.7528",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5945",
  "usage-tracker-core": "/usage-tracker-core/static-1.7378",
  "video-components-external": "/video-components-external/static-1.11864",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3528",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3543",
  "quartz-webpack": "/quartz-webpack/static-1.3490",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.344",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "customer-data-objects": "/customer-data-objects/static-1.7856",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8104",
  "laboratory-lib": "/laboratory-lib/static-3.7328",
  "onboarding-scopes": "/onboarding-scopes/static-1.6635",
  "seat-types-lib": "/seat-types-lib/static-1.408",
  "ui-addon-opt": "/ui-addon-opt/static-4.8537",
  "HeadJS": "/HeadJS/static-2.777",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3310",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.208",
  "ts-schema": "/ts-schema/static-1.4207",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8025",
  "content-media-capture": "/content-media-capture/static-1.5093",
  "cssUtils": "/cssUtils/static-1.843",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10002",
  "file-manager-components": "/file-manager-components/static-1.24148",
  "HubStyle": "/HubStyle/static-2.11959",
  "knowledge-content-types": "/knowledge-content-types/static-1.8584",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10060",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11325",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9257",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10439",
  "video-data-lib": "/video-data-lib/static-1.35522",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4500",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6435",
  "customer-data-properties": "/customer-data-properties/static-1.52186",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18941",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5259",
  "onboarding-tours": "/onboarding-tours/static-1.16937",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8273",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9252",
  "user-context": "/user-context/static-1.5287",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.852",
  "hubspotter-http": "/hubspotter-http/static-1.4778",
  "icons": "/icons/static-2.665",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.551",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.941",
  "quartz-head": "/quartz-head/static-1.931",
  "quartz-test": "/quartz-test/static-1.941",
  "quartz-tracking": "/quartz-tracking/static-1.645",
  "trellis-components": "/trellis-components/static-1.2304",
  "ui-fonts": "/ui-fonts/static-1.914",
  "usage-tracker-container": "/usage-tracker-container/static-1.7518",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9602",
  "data-token-picker": "/data-token-picker/static-1.16720",
  "FileManagerLib": "/FileManagerLib/static-1.39788",
  "property-translator": "/property-translator/static-1.5570",
  "atom": "/atom/static-1.5252",
  "merchandise-lib": "/merchandise-lib/static-1.267",
  "purchase-motions-components": "/purchase-motions-components/static-1.6177",
  "salesImages": "/salesImages/static-1.529",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5761",
  "react-create-root-preference": "/react-create-root-preference/static-1.45",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.102",
  "ui-images": "/ui-images/static-2.1206",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4547",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.2285",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3098",
  "foundations-theming-base": "/foundations-theming-base/static-1.3600",
  "stylex": "/stylex/static-1.37",
  "interframe": "/interframe/static-3.4932",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5942",
  "web-vitals": "/web-vitals/static-1.9",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.244",
  "chirp-fetch": "/chirp-fetch/static-1.2064",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4654",
  "react-flip-move": "/react-flip-move/static-1.74",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4828",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12897",
  "content-media-compositions": "/content-media-compositions/static-2.16904",
  "idb-keyval": "/idb-keyval/static-1.47",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4325",
  "magpie-lib": "/magpie-lib/static-1.5671",
  "magpie-types": "/magpie-types/static-1.5131",
  "media-bridge-lib": "/media-bridge-lib/static-1.19235",
  "bender-build-tools": "/bender-build-tools/static-1.3308",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3973",
  "superstore": "/superstore/static-1.4935",
  "feedback-loader": "/feedback-loader/static-1.29627",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9409",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8882",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29061",
  "ContentUtils": "/ContentUtils/static-1.68892",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4602",
  "sassPrefix": "/sassPrefix/static-1.160",
  "react-dnd-compat": "/react-dnd-compat/static-1.4791",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1361",
  "copilot-toolkit": "/copilot-toolkit/static-1.11593",
  "avatar-components": "/avatar-components/static-1.2675",
  "navigation-messaging": "/navigation-messaging/static-1.7834",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8352",
  "commerce-products-lib": "/commerce-products-lib/static-1.10228",
  "crm-message-bus": "/crm-message-bus/static-1.43491",
  "growth-data-modal": "/growth-data-modal/static-1.5719",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5053",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5151",
  "calling-global-api": "/calling-global-api/static-1.65119",
  "calling-internal-common": "/calling-internal-common/static-1.31489",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66501",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58795",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3924",
  "crm-links": "/crm-links/static-1.6491",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4265",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13207",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9730",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8273",
  "external-options-client-types": "/external-options-client-types/static-1.4253",
  "formula-editor": "/formula-editor/static-1.14572",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7071",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "hs-resources": "/hs-resources/static-1.355",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3715",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4344",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.809",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3819",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49327",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4094",
  "property-value-citations": "/property-value-citations/static-1.2800",
  "pulse": "/pulse/static-1.791",
  "smart-property-lib": "/smart-property-lib/static-1.8059",
  "tiered-pricing": "/tiered-pricing/static-1.1723",
  "topics-actions-lib": "/topics-actions-lib/static-1.326",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11166",
  "zustand": "/zustand/static-1.74",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3239",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2442",
  "navigation-components": "/navigation-components/static-1.18507",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1003",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7820",
  "ui-universal-auth": "/ui-universal-auth/static-1.9186",
  "batch-promise": "/batch-promise/static-1.1721",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18059",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10401",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5214",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1125",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "audio-components": "/audio-components/static-1.6180",
  "FileManagerCore": "/FileManagerCore/static-1.39647",
  "FileManagerImages": "/FileManagerImages/static-1.37299",
  "video-components": "/video-components/static-1.13866",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1303",
  "purchase-motions-api": "/purchase-motions-api/static-1.6180",
  "signup-constants": "/signup-constants/static-1.19321",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8235",
  "usage-tracker-public": "/usage-tracker-public/static-1.7339",
  "reactive-lib": "/reactive-lib/static-1.901",
  "simple-logging-lib": "/simple-logging-lib/static-1.3226",
  "chatspot-core": "/chatspot-core/static-1.22221",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6756",
  "cms-field-types": "/cms-field-types/static-1.4991",
  "content-icons-ui": "/content-icons-ui/static-1.2279",
  "integrations-lib": "/integrations-lib/static-1.16724",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-core": "/breeze-engine-core/static-1.639",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.952",
  "customer-data-tracking": "/customer-data-tracking/static-1.7062",
  "products-iframe-lib": "/products-iframe-lib/static-1.8363",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10785",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1368",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2266",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.512",
  "calling-error-reporting": "/calling-error-reporting/static-1.31496",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11213",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6717",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1636",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7425",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9788",
  "bark-lib": "/bark-lib/static-1.16663",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6064",
  "react-codemirror": "/react-codemirror/static-1.10810",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.190",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4133",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6976",
  "persist-promise": "/persist-promise/static-1.3878",
  "event-emitter": "/event-emitter/static-1.1127",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.294",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "data-agent-kit": "/data-agent-kit/static-1.474",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10486",
  "fsm": "/fsm/static-1.3906",
  "policy-lib": "/policy-lib/static-1.6962",
  "react-tinymce": "/react-tinymce/static-1.55720",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10549",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54846",
  "tinymce-plugins": "/tinymce-plugins/static-1.57960",
  "tinymce-themes": "/tinymce-themes/static-1.56816",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2470",
  "user-context-client": "/user-context-client/static-1.4727",
  "nest": "/nest/static-1.412",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.982",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4708",
  "video-embed": "/video-embed/static-1.36356",
  "social-insights-client-types": "/social-insights-client-types/static-1.22548",
  "flux-actions": "/flux-actions/static-1.352",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14139",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5784",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7957",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10541",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.700",
  "sales-views-client-types": "/sales-views-client-types/static-1.4435",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15297",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7783",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36413",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3712",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16094",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.107",
  "trellis-story-utils": "/trellis-story-utils/static-1.4683",
  "storybook-react": "/storybook-react/static-1.36",
  "hub-http-contrib": "/hub-http-contrib/static-1.3219",
  "tinymce-data": "/tinymce-data/static-1.40931",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5389",
  "layout-dnd-components": "/layout-dnd-components/static-1.12787",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11762",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15942",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9178",
  "outpost": "/outpost/static-1.4344",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3189",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.204",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.697",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.769",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.878",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.219",
  "slack-ui-library": "/slack-ui-library/static-1.10574",
  "ContentData": "/ContentData/static-1.68967",
  "layout-data-lib": "/layout-data-lib/static-1.10087",
  "advanced-menus-core": "/advanced-menus-core/static-1.15421",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12316",
  "ExportDialog": "/ExportDialog/static-6.10556",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34537",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15420",
  "simple-menus-lib": "/simple-menus-lib/static-1.16937"
}
};
